import src from "IMAGE";
export default { src, width: 644, height: 182, blurWidth: 0, blurHeight: 0};
